// Facility Management APIs
/**
 * @function ApiClient#GetFacilityList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetFacilityList(cid, options = {}) {
  return await this._get(`/community/${cid}/facility_list`, options);
}

/**
 * @function ApiClient#AddFacility
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} facilityData
 * @param {any} images
 * @param {any} options = {}
 */
export async function AddFacility(cid, facilityData, images, options = {}) {
  const formData = new FormData();
  formData.set("Data", JSON.stringify(facilityData));
  if (images) {
    images.forEach((img) => {
      formData.append("Image", img);
    });
  }
  return await this._post(`/community/${cid}/facility`, formData, options);
}

/**
 * @function ApiClient#UpdateFacility
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} facilityData
 * @param {any} images
 * @param {any} options = {}
 */
export async function UpdateFacility(cid, facilityData, images, options = {}) {
  const formData = new FormData();
  formData.set("Data", JSON.stringify(facilityData));

  if (images) {
    images.forEach((img) => {
      formData.append("Image", img);
    });
  }
  return await this._put(`/community/${cid}/facility`, formData, options);
}

/**
 * @function ApiClient#DeleteFacility
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} fID
 * @param {any} options = {}
 */
export async function DeleteFacility(cid, fID, options = {}) {
  return await this._delete(`/community/${cid}/facility/${fID}`, options);
}

/**
 * @function ApiClient#GetFacilityAvailableBookingTime
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} fID
 * @param {any} startDate
 * @param {any} startTime
 * @param {any} options = {}
 */
export async function GetFacilityAvailableBookingTime(cid, fID, startDate, startTime, options = {}) {
  return await this._get(`/community/${cid}/facility/${fID}/available_booking_time?sd=${startDate}&st=${startTime}`, options);
}

/**
 * @function ApiClient#GetFacilityUseDetail
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} fID
 * @param {any} date
 * @param {any} options = {}
 */
export async function GetFacilityUseDetail(cid, fID, date, options = {}) {
  return await this._get(`/community/${cid}/facility/${fID}/use_detail?d=${date}`, options);
}

/**
 * @function ApiClient#GetFacilityUseCount
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetFacilityUseCount(cid, options = {}) {
  return await this._get(`/community/${cid}/facility_use_count`, options);
}

// Booking APIs
/**
 * @function ApiClient#BookingFacility
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} fID
 * @param {any} bookingData
 * @param {any} startDate
 * @param {any} startTime
 * @param {any} endTime
 * @param {any} options = {}
 */
export async function BookingFacility(cid, fID, bookingData, startDate, startTime, endTime, options = {}) {
  return await this._post(`/community/${cid}/facility/${fID}/booking?sd=${startDate}&st=${startTime}&et=${endTime}`, bookingData, options);
}

/**
 * @function ApiClient#GetFacilityBookingList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.sortBy
 * @param {any} params.sortDesc
 * @param {any} params.page
 * @param {any} params.itemsPerPage
 * @param {any} params.facility
 * @param {any} params.building
 * @param {any} params.doorPlate
 * @param {any} params.floor
 * @param {any} params.startCheckDate
 * @param {any} params.endCheckDate
 * @param {any} params.startBookingDate
 * @param {any} params.endBookingDate
 * @param {any} params.startEnterDate
 * @param {any} params.endEnterDate
 * @param {any} params.startLeaveDate
 * @param {any} params.endLeaveDate
 * @param {any} params.status
 * @param {any} options = {}
 */
export async function GetFacilityBookingList(
  cid,
  {
    sortBy = "",
    sortDesc = "",
    page = "",
    itemsPerPage = "",
    facility = "",
    building = "",
    doorPlate = "",
    floor = "",
    startCheckDate = "",
    endCheckDate = "",
    startBookingDate = "",
    endBookingDate = "",
    startEnterDate = "",
    endEnterDate = "",
    startLeaveDate = "",
    endLeaveDate = "",
    status = "",
  } = {},
  options = {},
) {
  const url = `/community/${cid}/facility_booking_list?&p=${page}&sb=${sortBy}&sd=${sortDesc}&pp=${itemsPerPage}&fa=${facility}&b=${building}&d=${doorPlate}&f=${floor}&scd=${startCheckDate}&ecd=${endCheckDate}&sbd=${startBookingDate}&ebd=${endBookingDate}&sed=${startEnterDate}&eed=${endEnterDate}&sld=${startLeaveDate}&eld=${endLeaveDate}&s=${status}`;

  return await this._get(url, options);
}

/**
 * @function ApiClient#CancelFacilityBook
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} fID
 * @param {any} bID
 * @param {any} options = {}
 */
export async function CancelFacilityBook(cid, fID, bID, options = {}) {
  return await this._post(`/community/${cid}/facility/${fID}/booking/${bID}/cancel`, null, options);
}

/**
 * @function ApiClient#EnterFacility
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} fID
 * @param {any} bookingDataID = ""
 * @param {any} bookingData
 * @param {any} startTime = ""
 * @param {any} endTime = ""
 * @param {any} options = {}
 */
export async function EnterFacility(cid, fID, bookingDataID = "", bookingData, startTime = "", endTime = "", options = {}) {
  return await this._post(`/community/${cid}/facility/${fID}/enter?bdid=${bookingDataID}&st=${startTime}&et=${endTime}`, bookingData, options);
}

/**
 * @function ApiClient#LeaveFacility
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} fID
 * @param {any} bID
 * @param {any} options = {}
 */
export async function LeaveFacility(cid, fID, bID, options = {}) {
  return await this._post(`/community/${cid}/facility/${fID}/booking/${bID}/leave`, null, options);
}

// Borrow Item APIs
/**
 * @function ApiClient#GetFacilityBorrowItemList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetFacilityBorrowItemList(cid, options = {}) {
  return await this._get(`/community/${cid}/facility_borrow_item_list`, options);
}

/**
 * @function ApiClient#AddFacilityBorrowItem
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} itemName
 * @param {any} options = {}
 */
export async function AddFacilityBorrowItem(cid, itemName, options = {}) {
  return await this._post(`/community/${cid}/facility_borrow_item?i=${itemName}`, null, options);
}

/**
 * @function ApiClient#UpdateFacilityBorrowItem
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} items
 * @param {any} options = {}
 */
export async function UpdateFacilityBorrowItem(cid, items, options = {}) {
  return await this._put(`/community/${cid}/facility_borrow_item`, items, options);
}

/**
 * @function ApiClient#DeleteFacilityBorrowItem
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} itemName
 * @param {any} options = {}
 */
export async function DeleteFacilityBorrowItem(cid, itemName, options = {}) {
  return await this._delete(`/community/${cid}/facility_borrow_item?i=${itemName}`, options);
}
